var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPoop4 = function SvgPoop4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "poop_4_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 90,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h90v100H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#poop_4_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.782 49.812c-.065-7.524 7.055-12.872 16.34-13.707 9.285-.834 16.024 1.67 25.169 2.146 9.145.477 27.142-.408 32.387 4.623 5.244 5.031 7.062 11.348-2.37 16.83-9.43 5.483-20.514 4.172-34.698 4.65-14.183.475-36.71-.597-36.828-14.542Z",
    fill: "#3E5D3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.61 64.353c14.184-.477 25.269.834 34.699-4.648 9.43-5.483 7.613-11.8 2.37-16.83-1.986-1.906-5.803-2.962-10.272-3.566 4.94 1.29 6.85 4.21 5.361 8.274-1.489 4.065-6.987 7.045-20.199 6.702-13.21-.344-18.175.687-32.447.573-14.27-.114-14.594-8.588-11.485-14.556-3.045 2.397-4.888 5.668-4.855 9.51C5.9 63.757 28.427 64.829 42.61 64.353Z",
    fill: "#314F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.678 42.874a6.719 6.719 0 0 0-.579-.492c2.486 4.235 1.88 8.939-5.365 13.15-9.431 5.484-20.515 4.173-34.698 4.65-10.233.343-24.808-.12-32.179-5.641 4.654 9.463 23.379 10.228 35.754 9.812 14.183-.477 25.268.834 34.698-4.648 9.431-5.483 7.613-11.8 2.37-16.83ZM16.272 43.15c1.11-.886 2.43-1.463 3.743-2 1.887-.774 3.82-1.494 5.844-1.745 1.7-.209 3.44-.08 5.09.38 1.66.461 3.219 1.25 4.889 1.677 2.748.704 5.798.437 8.256 1.854.275.159.555.355.674.65.183.453-.083.976-.451 1.297-.99.865-2.476.707-3.777.527-4.229-.582-8.614-.828-12.695.424-.953.292-1.88.663-2.832.954-1.196.366-2.428.604-3.661.809-.967.16-1.95.302-2.925.198-.975-.102-1.954-.476-2.612-1.202-.659-.726-.928-1.843-.501-2.725.214-.44.576-.792.958-1.098Z",
    fill: "#233E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.622 43.962c.139-.203.344-.35.557-.471.93-.525 2.041-.59 3.109-.633 1.853-.076 3.712-.122 5.562.026.865.068 1.785.205 2.432.782.648.577.834 1.741.151 2.277-.364.285-.858.322-1.32.347l-3.98.211c-1.49.08-2.996.158-4.469-.088-.627-.106-1.274-.285-1.735-.724-.46-.438-.666-1.201-.307-1.727Z",
    fill: "#233E20"
  }))));
};
export default SvgPoop4;